"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = void 0;
/**
 * Głębokie kopiowanie
 * @param data date do skopiowania
 */
function deepCopy(data) {
    return JSON.parse(JSON.stringify(data));
}
exports.deepCopy = deepCopy;
exports.default = deepCopy;
//# sourceMappingURL=deepCopy.js.map